export const generativeAiAgentsTerritories = "/generative_ai/agents/territories";
